import { useTranslation } from "react-i18next";
import {
  Form,
  Input,
  SignupField,
  StyledLockIcon,
  StyledMailIcon,
  StyledUserIcon,
  StyledVisibility,
  StyledVisibilityOff,
} from "./SignupPage.style";

import Icon from "../../../components/utils/Icon";

const SignUpFormComponent = ({
  ar,
  fullName,
  setFullName,
  checkValidation,
  email,
  setEmail,
  visibility,
  visibility2,
  confirmPassword,
  password,
  setPassword,
  setConfirmPassword,
  setVisibility,
  setVisibility2,
}) => {
  const { t } = useTranslation();

  const handleVisibilityToggle = () => {
    setVisibility(!visibility);
  };

  const handleVisibilityToggle2 = () => {
    setVisibility2(!visibility2);
  };
  return (
    <Form>
      <SignupField>
        <StyledUserIcon $ar={ar} />

        <Input
          $ar={ar}
          $error={checkValidation && !fullName}
          type="text"
          placeholder={t("full-name")}
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />
      </SignupField>

      <SignupField>
        <StyledMailIcon $ar={ar} />
        <Input
          $ar={ar}
          $error={checkValidation && !email}
          type="text"
          placeholder={t("email-address")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </SignupField>
      <SignupField>
        <StyledLockIcon $ar={ar} />
        <Input
          $ar={ar}
          type={visibility ? "text" : "password"}
          placeholder={t("password")}
          $error={checkValidation && !password}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {visibility ? (
          <Icon
            icon={<StyledVisibility onClick={handleVisibilityToggle} />}
            selectedLocale={ar}
          />
        ) : (
          <Icon
            icon={<StyledVisibilityOff onClick={handleVisibilityToggle} />}
            selectedLocale={ar}
          />
        )}
      </SignupField>
      <SignupField>
        <StyledLockIcon $ar={ar} />
        <Input
          $ar={ar}
          type={visibility2 ? "text" : "password"}
          placeholder={t("confirm-password")}
          $error={
            checkValidation &&
            (!confirmPassword || password !== confirmPassword)
          }
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        {visibility2 ? (
          <Icon
            icon={<StyledVisibility onClick={handleVisibilityToggle2} />}
            selectedLocale={ar}
          />
        ) : (
          <Icon
            icon={<StyledVisibilityOff onClick={handleVisibilityToggle2} />}
            selectedLocale={ar}
          />
        )}
      </SignupField>
    </Form>
  );
};

export default SignUpFormComponent;
